import React, { useState, useEffect, useContext } from "react";
import { Input } from "antd";

import Style from "../questionItem.module.scss";
import { previewExamContext } from "../../../context";

interface IProps {
    homeworkState: number;
    list: {
        answerId: number;
        stuAnswer: string;
        content: string;
        isRight: BooleanValue;
    }[];
    onChange: (answerId: number, value: string) => void;
}

export const Tiankong = ({ list, homeworkState, onChange }: IProps) => {
    const handleChange = (answerId: number, value: string) => {
        if (homeworkState === 2) return;
        onChange(answerId, value);
    };
    const { showAnswer } = useContext(previewExamContext);
    return (
        <>
            {list.map((item, index) => (
                <div
                    key={item.answerId}
                    className={`${Style.option} ${Style.tiankong}`}>
                    {`（${index + 1}）、`}
                    <div style={{ width: 150 }}>
                        <TiankongItem
                            content={item.stuAnswer}
                            onChange={(value: string) =>
                                handleChange(item.answerId, value)
                            }
                        />
                    </div>
                    {showAnswer && item.content && (
                        <div className={Style.tkRight}>
                            <span className={Style.tkTop}>正确答案：</span>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: item.content
                                }}
                            />
                        </div>
                    )}
                </div>
            ))}
        </>
    );
};

interface TiankongItemProps {
    content: string;
    onChange: (value: string) => void;
}

export const TiankongItem = ({ content, onChange }: TiankongItemProps) => {
    let [value, setValue] = useState("");
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
    };

    const setOptionValue = () => {
        onChange(value);
    };

    useEffect(() => {
        setValue(content);
    }, []);

    return (
        <Input onChange={handleChange} onBlur={setOptionValue} value={value} />
    );
};
